<!-- header -->
<app-header></app-header>

<mat-drawer-container class="left-right-drawer-height" autosize >
  <mat-drawer   #leftNavMenuDrawer class="mat-drawer" mode="side" position="start">
	<app-menu-left></app-menu-left>
  </mat-drawer>

  <mat-drawer #rightNavMenuDrawer class="example-sidenav" mode="side" position="end">
  	<app-menu-right></app-menu-right>
  </mat-drawer>
  
  <div class="runtime-message-class">
    &nbsp;
  </div>
<!-- routes will be rendered here -->
<router-outlet></router-outlet>
</mat-drawer-container>



<!-- footer -->
<app-footer></app-footer>
